import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type AddReviewSuccessActionData, type InitSuccessActionData } from "./actions";
import { type ProductDetail } from "./types";

const reducer = (state: ProductDetail.AppState, action: ReduxAction<any>): ProductDetail.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: "Loading"
      };
    }
    case Actions.InitFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.InitSuccess: {
      const data = action.data as InitSuccessActionData;

      return {
        ...state,
        ...data,
        hasCart: false,
        status: "Ready"
      };
    }

    case Actions.SaveReviewBegin: {
      return {
        ...state,
        reviewError: null,
        status: "SavingReview"
      };
    }
    case Actions.SaveReviewFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        reviewError: error,
        status: "Failed"
      };
    }
    case Actions.SaveReviewSuccess: {
      const review = action.data as AddReviewSuccessActionData;
      return {
        ...state,
        status: "Ready",
        product: {
          ...state.product!,
          userReview: review
        }
      };
    }

    case Actions.AddToCartBegin: {
      return {
        ...state,
        status: "AddingToCart"
      };
    }
    case Actions.AddToCartFailure: {
      return {
        ...state,
        status: "Failed"
      };
    }
    case Actions.AddToCartSuccess: {
      return {
        ...state,
        hasCart: true,
        status: "Ready"
      };
    }
    default:
      return state;
  }
};

export const defaultState: ProductDetail.AppState = {
  canReview: false,
  cartUrl: "",
  hasCart: false,
  id: "",
  currencyCode: "",
  status: "None",
  product: null,
  productVariants: [],
  reviewError: null,
  shouldDisplayTax: false
};
export const previewState: ProductDetail.AppState = {
  ...defaultState,
  currencyCode: "USD",
  status: "Ready",
  product: {
    allowReviews: true,
    id: "",
    name: "Dummy",
    options: [],
    userReview: null
  }
};
export default wrapReducer({ defaultState, reducer, previewState });
